const IS_PRODUCTION = process.env.NEXT_PUBLIC_ENVIRONMENT === "production";

export const CHILI_PIPER_DOMAIN = "snackmagic";
export const CHILI_PIPER_SM_ROUTER = IS_PRODUCTION ? "booking-router" : "inbound-router";
export const CHILI_PIPER_SWAG_ROUTER = IS_PRODUCTION ? "swag_router" : "swag_router--test";
export const CHILI_PIPER_SWAG_CATALOG_ROUTER = IS_PRODUCTION
  ? "swag-catalog-router"
  : "inbound-router";
export const CHILI_PIPER_STADIUM_ROUTER = IS_PRODUCTION ? "stadium_router" : "test-inbound-router";

export const CHILI_PIPER_JS_URL = "https://snackmagic.chilipiper.com/concierge-js/cjs/concierge.js";
export const CHILI_PIPER_OPTIONS = {
  titleStyle: "Thanks! What time works best for a quick call?",
  debug: !IS_PRODUCTION,
  map: true,
  trigger: "ThirdPartyForm",
};

export const SNACKMAGIC = "snackmagic";
export const SWAGMAGIC = "swagmagic";
export const SWAGMAGIC_CATALOG = "swagmagic-catalog";
export const STADIUM = "stadium";
